const EVENT_USER_MODAL_CLOSED = 'event-user-modal::close';
const EVENT_USER_MODAL_OPENED = 'event-user-modal::opened';

export { EVENT_USER_MODAL_CLOSED };
export { EVENT_USER_MODAL_OPENED };
